import { useForm, ValidationError } from "@formspree/react";

export function RequestAccessPage() {
  const [state, handleSubmit] = useForm("mojzwaev");

  return (
    <div className="max-w-6xl mx-auto px-6 py-20">
      <div className="max-w-md mx-auto space-y-8">
        <div className="space-y-3">
          <h1 className="text-3xl font-bold tracking-tight">Request early access</h1>
          <p className="text-muted-foreground">
            We&apos;re onboarding campaigns on a rolling basis. Drop your info and we&apos;ll be in touch.
          </p>
        </div>

        {state.succeeded ? (
          <div className="rounded-lg border bg-card p-6 text-center space-y-2">
            <p className="font-medium">You&apos;re on the list!</p>
            <p className="text-sm text-muted-foreground">
              We&apos;ll be in touch soon.
            </p>
          </div>
        ) : (
          <form onSubmit={(e) => void handleSubmit(e)} className="space-y-4">
            <div className="space-y-1.5">
              <label htmlFor="email" className="text-sm font-medium">Email</label>
              <input
                id="email"
                type="email"
                name="email"
                required
                className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                placeholder="you@campaign.org"
              />
              <ValidationError field="email" errors={state.errors} className="text-sm text-destructive" />
            </div>

            <div className="space-y-1.5">
              <label htmlFor="organization" className="text-sm font-medium">Campaign or organization</label>
              <input
                id="organization"
                type="text"
                name="organization"
                required
                className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                placeholder="Friends of Jane Smith"
              />
              <ValidationError field="organization" errors={state.errors} className="text-sm text-destructive" />
            </div>

            <div className="space-y-1.5">
              <label htmlFor="role" className="text-sm font-medium">Your role</label>
              <input
                id="role"
                type="text"
                name="role"
                className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                placeholder="Campaign manager, field director…"
              />
            </div>

            <ValidationError errors={state.errors} className="text-sm text-destructive" />

            <button
              type="submit"
              disabled={state.submitting}
              className="w-full bg-primary hover:bg-primary/90 disabled:opacity-60 text-white font-semibold text-sm rounded-md px-4 py-2.5 transition-colors"
            >
              {state.submitting ? "Submitting…" : "Request early access"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
